import { Context, type Effect, Layer } from "effect";
import type { EditorHighlightDependencyFailure, EditorHighlightFailure } from "./highlight-model.ts";

export class EditorHighlightIo extends Context.Service<EditorHighlightIo, {
  readonly colorize: (text: string, language: string) => Effect.Effect<unknown, EditorHighlightDependencyFailure>;
}>()("workerstation/frontend/EditorHighlightIo") {}
export const EditorHighlightIoTest = (ports: typeof EditorHighlightIo.Service) => Layer.succeed(EditorHighlightIo, ports);

export class EditorHighlights extends Context.Service<EditorHighlights, {
  readonly render: (request: unknown) => Effect.Effect<string, EditorHighlightFailure>;
}>()("workerstation/frontend/EditorHighlights") {}
export const EditorHighlightsTest = (ports: typeof EditorHighlights.Service) => Layer.succeed(EditorHighlights, ports);
